import { render } from "./UnreadMessagesCounter.vue?vue&type=template&id=68e76ca7&scoped=true&ts=true"
import script from "./UnreadMessagesCounter.vue?vue&type=script&lang=ts"
export * from "./UnreadMessagesCounter.vue?vue&type=script&lang=ts"

import "./UnreadMessagesCounter.vue?vue&type=style&index=0&id=68e76ca7&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68e76ca7"]])

export default __exports__